import React from "react";

/** Şart ve koşullar metni + onay kutusu + buton (ilk girişte ve aynı gün tekrar girişte). */
const DisclaimerView = ({ text, agreed, onAgreedChange, busy, onSubmit }) => (
  <div className="cmp-card-body cmp-disclaimer">
    <h2 className="cmp-panel-title">Şart ve Koşullar</h2>
    <div className="cmp-disclaimer-text">{text}</div>
    <label className="cmp-check">
      <input
        type="checkbox"
        checked={agreed}
        onChange={(e) => onAgreedChange(e.target.checked)}
      />
      Şart ve koşulları okudum, anladım ve kabul ediyorum.
    </label>
    <button
      type="button"
      className="cmp-btn cmp-btn-primary"
      disabled={busy}
      onClick={onSubmit}
    >
      {busy ? "Kaydediliyor…" : "Onaylıyorum"}
    </button>
  </div>
);

export default DisclaimerView;
